import { EditCustomerOutDto, EditCustomerInDto } from '../../../types/customer.dto'

export const EDIT_CUSTOMER = 'EDIT_CUSTOMER'
export const EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS'
export const EDIT_CUSTOMER_ERROR = 'EDIT_CUSTOMER_ERROR'
export const RESET_EDIT_CUSTOMER = 'RESET_EDIT_CUSTOMER'

export interface EditCustomer {
  type: typeof EDIT_CUSTOMER
  payload: EditCustomerOutDto
}

export interface EditCustomerSuccess {
  type: typeof EDIT_CUSTOMER_SUCCESS
  payload: EditCustomerInDto
}

export interface EditCustomerError {
  type: typeof EDIT_CUSTOMER_ERROR
  payload: string | boolean
}

export interface ResetEditCustomer {
  type: typeof RESET_EDIT_CUSTOMER
  payload: null
}
export interface State {
  data: EditCustomerInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCustomer | EditCustomerSuccess | EditCustomerError | ResetEditCustomer
